// extracted by mini-css-extract-plugin
module.exports = {"sider_box":"sider_box-2Okrlnim","stock_box":"stock_box-rXMcCvJS clearfix","sider_list":"sider_list-3393I5F5"};